import React, { useMemo } from 'react';
import { useWidgetLoader } from './useWidgetLoader';

type Props = {
  company: string;
  sitename: string;
  view?: string;
  embedType?: 'widget' | 'iframe' | 'link';
};

export const DemoWidget: React.FC<Props> = ({ company, sitename, view, embedType = 'widget' }) => {
  const { loaded, error } = useWidgetLoader();
  const key = useMemo(() => `${company}-${sitename}-${view || 'default'}`, [company, sitename, view]);

  if (error) {
    return <div className="text-slate-400">Failed to load widget script. Please check your network.</div>;
  }
  const url = process.env.NODE_ENV === 'development' ? 'http://localhost:3008' : 'https://bostad-cloud.pintar.se';
  if (embedType === 'iframe') {
    const src = `${url}/${company}/${sitename}${view ? `/${view}` : ''}`;
    return <iframe key={key} src={src} className="h-[1100px] w-full" title="Housing widget iframe preview" />;
  }

  if (embedType === 'link') {
    const href = `${url}/${company}/${sitename}${view ? `/${view}` : ''}`;
    return (
      <div>
        <a href={href} target="_blank" rel="noopener noreferrer" className="text-sky-400 underline">
          Öppna i ny flik
        </a>
      </div>
    );
  }

  // Default: native widget element
  return (
    <div>
      {view ? (
        <pintar-studios-webtools key={key} company={company} sitename={sitename} view={view}></pintar-studios-webtools>
      ) : (
        <pintar-studios-webtools key={key} company={company} sitename={sitename}></pintar-studios-webtools>
      )}
      {!loaded && <div className="mt-3 text-slate-400">Loading widget script…</div>}
    </div>
  );
};
